import { Link } from "@/i18n/navigation";
import { useLocale, useTranslations } from "next-intl";

export default function CredError(){

    const t = useTranslations("error.page.cred");
    const locale = useLocale();

    return(
        <div className="m-4 bg-error/40 rounded-md p-2">
            <h1 className="font-bold">{t("title")}</h1>
            <Link locale={locale} href="/login" className="text-accent-2 font-semibold">{t("login")}</Link>
        </div>
    )
}